import { render, staticRenderFns } from "./SalaryTemplate.vue?vue&type=template&id=70375967&"
import script from "./SalaryTemplate.vue?vue&type=script&lang=js&"
export * from "./SalaryTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports